var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0d0d0",
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.061,
    stopColor: "#f30410",
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#e90512",
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#e00612",
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#d90713",
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#d40713",
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#d00814",
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#ce0814",
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#cc0814",
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc0814",
    stopOpacity: 0.051
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff000f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.061,
    stopColor: "#f30410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#e90512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#e00612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#d90713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#d40713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#d00814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#ce0814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#cc0814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc0814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff000f",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fe010f",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#fb0210",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f60410",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#f00511",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#e90511",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#e10612",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#da0713",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#d20814",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc0814",
    stopOpacity: 0.251
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.5,
    y1: 0.003,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a5a2a",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    stopColor: "#995929",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#955728",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#8f5325",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#894f22",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#814a1f",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#7a441b",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopColor: "#734017",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#6e3c14",
    stopOpacity: 0.851
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c3b13",
    stopOpacity: 0.851
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0.5,
    y1: 0.003,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 0.5,
    y1: 0.002,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.061,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#454545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3f3f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-results",
    transform: "translate(-850 -107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NoResults",
    transform: "translate(850 108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M171.877,41.473c35.741,15.992,68.943,40.034,79.916,73.3s-.236,75.735-25.3,96.9C202.23,232.191,165,232.686,128.8,231.727l-3.355-.092c-37.281-1.041-73-3.017-96.257-23.48C5.861,187.668-4.963,148.671,2.17,112.52c7.11-36.2,32.2-69.5,63.93-82.207S136.135,25.481,171.877,41.473Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(15 53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M64.5,7.362l.23.042c2.353.475,21.958,5.423,21.958,38.273,0,34.947,44.738,1.754,67.868-13.4s52.928-13.965,59.236-2.6S198.8,46.946,202.436,80.625c3.31,30.685,20.542,43.168,23.581,61.186a73.958,73.958,0,0,1-14.522,16.867C187.23,179.191,150,179.686,113.8,178.727l-3.355-.092c-37.281-1.041-73-3.017-96.257-23.48A73.943,73.943,0,0,1,.985,139.67C1.7,131.548,5.365,122.231,14,111.9l.451-.535a46.993,46.993,0,0,0,11.355-32l-2.466-5.507Q15.134,55.6,10.3,46L9.71,44.836C4.626,34.878,5.992,22.09,20.341,10.444,42.63-7.662,64.5,7.362,64.5,7.362Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M64.5,7.362l.23.042c2.353.475,21.958,5.423,21.958,38.273,0,34.947,44.738,1.754,67.868-13.4s52.928-13.965,59.236-2.6S198.8,46.946,202.436,80.625c3.31,30.685,20.542,43.168,23.581,61.186a73.958,73.958,0,0,1-14.522,16.867C187.23,179.191,150,179.686,113.8,178.727l-3.355-.092c-37.281-1.041-73-3.017-96.257-23.48A73.943,73.943,0,0,1,.985,139.67C1.7,131.548,5.365,122.231,14,111.9l.451-.535a46.993,46.993,0,0,0,11.355-32l-2.466-5.507Q15.134,55.6,10.3,46L9.71,44.836C4.626,34.878,5.992,22.09,20.341,10.444,42.63-7.662,64.5,7.362,64.5,7.362Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 8.411,
    cy: 8.421,
    rx: 8.411,
    ry: 8.421,
    transform: "translate(31.696 59.573)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 5.677,
    cy: 5.684,
    rx: 5.677,
    ry: 5.684,
    transform: "translate(20.342 72.625)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 3.154,
    cy: 3.158,
    rx: 3.154,
    ry: 3.158,
    transform: "translate(23.706 62.099)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 3.154,
    cy: 3.158,
    rx: 3.154,
    ry: 3.158,
    transform: "translate(64 15)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 8.411,
    cy: 8.421,
    rx: 8.411,
    ry: 8.421,
    transform: "translate(204.959 116.415)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 3.154,
    cy: 3.158,
    rx: 3.154,
    ry: 3.158,
    transform: "translate(8.146 22.099)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 3.154,
    cy: 3.158,
    rx: 3.154,
    ry: 3.158,
    transform: "translate(1 123)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 14.929,
    cy: 14.947,
    rx: 14.929,
    ry: 14.947,
    transform: "translate(48.939 109.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 14.929,
    cy: 14.947,
    rx: 14.929,
    ry: 14.947,
    transform: "translate(48.939 109.257)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 10.093,
    cy: 10.105,
    rx: 10.093,
    ry: 10.105,
    transform: "translate(152.392 126.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 10.093,
    cy: 10.105,
    rx: 10.093,
    ry: 10.105,
    transform: "translate(152.392 126.099)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M133.093,163a10.109,10.109,0,0,1,8.29,15.871c-5.464.15-10.988.156-16.521.084A10.109,10.109,0,0,1,133.093,163Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M133.093,163a10.109,10.109,0,0,1,8.29,15.871c-5.464.15-10.988.156-16.521.084A10.109,10.109,0,0,1,133.093,163Z",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 5.467,
    cy: 5.474,
    rx: 5.467,
    ry: 5.474,
    transform: "translate(195.708 78.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 5.467,
    cy: 5.474,
    rx: 5.467,
    ry: 5.474,
    transform: "translate(195.708 78.52)",
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 10.934,
    cy: 10.947,
    rx: 10.934,
    ry: 10.947,
    transform: "translate(149.448 23.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 10.934,
    cy: 10.947,
    rx: 10.934,
    ry: 10.947,
    transform: "translate(149.448 23.784)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 5.257,
    cy: 5.263,
    rx: 5.257,
    ry: 5.263,
    transform: "translate(54.826 0.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 5.257,
    cy: 5.263,
    rx: 5.257,
    ry: 5.263,
    transform: "translate(54.826 0.204)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 5.257,
    cy: 5.263,
    rx: 5.257,
    ry: 5.263,
    transform: "translate(38.004 105.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 5.257,
    cy: 5.263,
    rx: 5.257,
    ry: 5.263,
    transform: "translate(38.004 105.046)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 5.257,
    cy: 5.263,
    rx: 5.257,
    ry: 5.263,
    transform: "translate(6 131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 5.257,
    cy: 5.263,
    rx: 5.257,
    ry: 5.263,
    transform: "translate(6 131)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 5.257,
    cy: 5.263,
    rx: 5.257,
    ry: 5.263,
    transform: "translate(204 41)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 5.677,
    cy: 5.684,
    rx: 5.677,
    ry: 5.684,
    transform: "translate(198.652 132.836)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 3.154,
    cy: 3.158,
    rx: 3.154,
    ry: 3.158,
    transform: "translate(213.791 138.309)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(70 44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M42.739,52.255l.507-.576c3.43-3.851,9.622-9.8,24.929-18.4C86.8,22.816,80.789,5.048,66.636,1,62.336-.23,57.361,2.833,52,3.923c-2.461.5-7.974-3.288-14.555-.508C33.2,5.208,34.342,7.4,32.518,9.071s-7.525.548-9.662,5.344c-1.266,2.841.24,6.316-.429,8.5s-3.193,3.822-3.816,6.757a9.649,9.649,0,0,0,7.424,11.45,9.7,9.7,0,0,0,7.521,11.131,9.587,9.587,0,0,0,4.737-.184A3.143,3.143,0,0,0,42.739,52.255Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M42.7,48.956l2.748-16.09h0c-7.527-.212-4.918-14.14,1.9-9.417,1.45,1.327,6.235,1.1,7.308-7.589,6.5,10.024,17.576,1.622,16.931,9.946l-.1,1.162c-1,10.973-4.177,21.663-10.885,20.481a13.215,13.215,0,0,1-2.224-.625l-.838,4.75h0q-.524,2.969,2.646,7.753L40.424,56.592A45.092,45.092,0,0,0,42.7,48.956Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M42.7,48.956l2.748-16.09h0c-7.527-.212-4.918-14.14,1.9-9.417,1.45,1.327,6.235,1.1,7.308-7.589,6.5,10.024,17.576,1.622,16.931,9.946l-.1,1.162c-1,10.973-4.177,21.663-10.885,20.481a13.215,13.215,0,0,1-2.224-.625l-.838,4.75h0q-.524,2.969,2.646,7.753L40.424,56.592A45.092,45.092,0,0,0,42.7,48.956Z",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M48.894,40.526a26.294,26.294,0,0,0,8.944,6.067l.548.229-.533,2.967Q50.352,47.243,48.894,40.526Z",
    fill: "#6c3b13",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M33,101.578c9.507,5.966,23.97,10.606,49.16,10.166l.46-12.725-.669.093c-2.9.356-14.959,1.37-30.1-3.843l-.529-.184C33.635,88.853,23.493,95.613,33,101.578Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M82.309,99.208q4.123,3.082,4.376,6.159c.253,3.076-.044,6.328-.534,6.493a30.772,30.772,0,0,1-4.045.071q-.275-.017-.25-.732c.469-2.7-.477-9.74-1.925-11.949Z",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M60.417,77.552l3.366,9.359-.163,1.549c-.789,8.109-.29,45.679,10.6,78.948q.127.389.256.775-28.014,0-29.959-7.695T60.417,77.552Z",
    fill: "#bfbfbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M56.424,135.1l9.4,27.832.235,1.032c1.609,7.157,3.181,15.921,4.509,24-3.921-.045-7.849-.132-11.764-.236l-3.355-.092q-4.771-.133-9.5-.3l-.454-1.25h0l-2.417-6.572.031,1.006.108,4.273c.016.684.028,1.509.038,2.442-9.5-.377-18.819-.943-27.766-2l-.393-2.145c-1.379-7.589-2.529-14.722-2.956-19.414l-.087-1.053-.02-.422a6.831,6.831,0,0,1,.057-1.117,2.858,2.858,0,0,1,2.961-2.7l.309-.009.36.01c6.727.367,20.733,10.665,25.535,14.342l1.282,1Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M112.7,22.333c3.159.6,4.621,6.885,3.262,14.037-1.2,6.313-4.194,11.194-7.054,11.837l-1.319,10.207-2.645-.452,1.474-10.42c-2.186-1.914-3.043-7.322-1.9-13.345A29.083,29.083,0,0,1,105.31,31,24.35,24.35,0,0,1,106.6,27.69a14.258,14.258,0,0,1,2.555-3.826l.231-.225a4.468,4.468,0,0,1,2.595-1.34A2.641,2.641,0,0,1,112.7,22.333Zm-1.512,1.828c-2.208.038-4.783,4.48-5.885,10.289-1.128,5.938-.3,11.112,1.841,11.779l.177.044c2.215.422,4.909-3.924,6.12-9.782l.1-.478.121-.682c.939-5.649.1-10.456-1.964-11.1l-.176-.044-.164-.022Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M111.187,24.161c-2.208.038-4.783,4.48-5.885,10.289-1.128,5.938-.3,11.112,1.841,11.779l.177.044c2.215.422,4.909-3.924,6.12-9.782l.1-.478c1.125-5.939.3-11.112-1.843-11.78l-.176-.044-.164-.022Z",
    fill: "rgba(255,255,255,0.75)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M106.873,50.348c1.326-.023,2.488,1.324,2.85,2.367q.361,1.042-.012,8.748a11.666,11.666,0,0,1-1.272,3.806q-.6,1.141-3.432,2.512L103.96,78.02l-6.254-8.543,3.7-11.331.26-.819c.915-2.919,1.388-4.9,1.827-5.87C103.975,50.4,105.547,50.372,106.873,50.348Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M106.873,50.348c1.326-.023,2.488,1.324,2.85,2.367q.361,1.042-.012,8.748a11.666,11.666,0,0,1-1.272,3.806q-.6,1.141-3.432,2.512L103.96,78.02l-6.254-8.543,3.7-11.331.26-.819c.915-2.919,1.388-4.9,1.827-5.87C103.975,50.4,105.547,50.372,106.873,50.348Z",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M67.375,60.769q6.307,11.344-.281,21.453-6.584,12.861-6.112,36.591L59.4,140c.518,19.1,2.2,36.432,2.2,36.432l-3.017-.054c-6.575-.145-11.419,2.18-27.279-2.085S10.35,167.511,0,160.625q18.4-19,24.6-61.915l.3-1.231C29.68,77.356,35.758,53.784,42,53.091s9.1-1.775,16.585.78A15.278,15.278,0,0,1,67.375,60.769Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M69.477,66.182c11.022,15.2,16.588,22.478,17.5,22.462q1.539-.027,9.871-19.9l8.676,7.209-1,4.424q-5.64,24.627-7.4,26.868A8.888,8.888,0,0,1,86,109.517c-4.933-2.439-31.169-24.775-36.1-31.772l-.433-.622c-1.96-2.635-1.54-12.746,4.176-17.264Q64.433,51.328,69.477,66.182Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M96.195,70.255c-.628-.758-.019-3.38,1.277-4.021s8.831,4.781,9.6,5.664-.633,5.267-1.535,4.65l-.961-.628C102.23,74.408,96.718,70.887,96.195,70.255Z",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M41.623,53.091c0-1.2-.263-1.63.837-2.887s13.279.629,15.013.932,1.616,4.229,0,4.229Q41.623,54.286,41.623,53.091Z",
    fill: "#d1d1d1"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 256,
    height: 256,
    transform: "translate(850 107)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/NotFound.3d594ab1.svg";
export { ForwardRef as ReactComponent };